module.exports = __webpack_public_path__ + "statics/img/cate9-4@2x.2bdf0271.png";